const TAB_KEY = 'basic-info'
export default {
  name: 'basicInfoTab',

  computed: {
    basicInfoTabConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: 'profile/get-basic-info',
            method: 'get'
          },
          post: {
            module: 'base',
            route: 'profile/update-basic-info',
            method: 'post',
            usePatch: false
          }
        },
        hiddenFormKeys: [
          'avatar_url'
        ],
        modifyDataBeforeSend: (event) => this.onProfileBasicInfoModifyData(event),
        onDataReceived: (event) => {
          const { permissions } = event?.meta || {}
          this.permissions = permissions
        },
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base/profile.basic_info'),
            showButtons: true,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                images: {
                  keys: [
                    'avatar_url'
                  ],
                  style: {
                    width: '120px',
                    height: '120px',
                    borderRadius: '70px'
                  },
                  default_image: '/public/base/images/default-avatar.png'
                },
                columnsCount: 2,
                fields: [
                  {
                    key: 'first_name',
                    label: this.$t('base/user.first_name'),
                    placeholder: this.$t('base/profile.firstname_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'last_name',
                    label: this.$t('base/user.last_name'),
                    placeholder: this.$t('base/profile.lastname_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'username',
                    label: this.$t('base/user.username'),
                    placeholder: this.$t('base/profile.username_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'email',
                    label: this.$t('base/user.email'),
                    placeholder: this.$t('base/profile.email_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            type: 'dynamic-columns',
            title: this.$t('base.user_contacts'),
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            key: 'contacts',
            display_props: ['type_id', 'value'],
            useInitialAutocompletes: true,
            headers: [this.$t('base/contact_type.type'), this.$t('base/contact_type.value')],
            fields: [
              {
                key: 'type_id',
                type: 'autocomplete',
                placeholder: this.$t('base/profile.select_type_placeholder'),
                autocomplete_options: {
                  module: 'base',
                  route: 'contact-types/autocomplete',
                  fetchInitial: false
                },
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'value',
                placeholder: this.$t('base/profile.value_placeholder'),
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onProfileBasicInfoModifyData (event) {
      const { copiedData } = event || {}
      if (!copiedData?.contacts?.length) {
        delete copiedData.contacts
      }

      return copiedData
    }
  }
}
